import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';

export default function PrivacyPolicyPage() {
  return (
    <>
      <Navbar />
      <main className="pb-16 md:pb-0 pt-24 md:pt-28">
        <div className="mx-auto px-4 md:px-6 py-12 md:py-16" style={{ maxWidth: '860px' }}>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-2">
            Политика конфиденциальности
          </h1>
          <p className="text-sm text-foreground-500 mb-10">Последнее обновление: июль 2025 г.</p>

          <div className="prose-content flex flex-col gap-8 text-sm md:text-base text-foreground-700 leading-relaxed">
            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">1. Общие положения</h2>
              <p>Настоящая политика конфиденциальности (далее — «Политика») определяет порядок обработки и защиты персональных данных пользователей сайта мастерской «Художественная ковка» (далее — «Мастерская», «мы»).</p>
              <p className="mt-3">Используя наш сайт и оставляя заявки, вы соглашаетесь с условиями настоящей Политики.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">2. Какие данные мы собираем</h2>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Имя и фамилия (при заполнении форм обратной связи);</li>
                <li>Контактный телефон и/или адрес электронной почты;</li>
                <li>Сообщения и запросы, которые вы нам направляете;</li>
                <li>Технические данные: IP-адрес, тип браузера, страницы посещения (в обезличенном виде).</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">3. Цели обработки данных</h2>
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Ответ на ваши запросы и обратная связь;</li>
                <li>Расчёт стоимости и согласование условий заказа;</li>
                <li>Уведомление о статусе заказа;</li>
                <li>Улучшение качества работы сайта и услуг.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">4. Передача данных третьим лицам</h2>
              <p>Мы не передаём ваши персональные данные третьим лицам без вашего согласия, за исключением случаев, предусмотренных законодательством Российской Федерации.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">5. Защита данных</h2>
              <p>Мы принимаем разумные организационные и технические меры для защиты ваших данных от несанкционированного доступа, изменения, раскрытия или уничтожения.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">6. Ваши права</h2>
              <p>Вы вправе в любое время запросить уточнение, исправление или удаление ваших персональных данных, обратившись к нам по телефону <a href="tel:+79174131562" className="text-primary-600 hover:text-primary-500">+7 917 413-15-62</a> или через мессенджеры.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">7. Изменения политики</h2>
              <p>Мы оставляем за собой право вносить изменения в настоящую Политику. Актуальная версия всегда доступна на данной странице.</p>
            </section>

            <section>
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3">8. Контакты</h2>
              <p>По вопросам, связанным с обработкой персональных данных, обращайтесь:</p>
              <ul className="list-none pl-0 mt-2 flex flex-col gap-1">
                <li>Телефон: <a href="tel:+79174131562" className="text-primary-600 hover:text-primary-500">+7 917 413-15-62</a></li>
                <li>WhatsApp: <a href="https://wa.me/79174131562" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-500">Написать</a></li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}